import {
  Component,
  ViewChild,
  OnInit,
  ElementRef,
  NgZone
} from "@angular/core";
import { AuthService } from "../../core/auth.service";
import { CamperVan } from "../../models/campervan";
import { FireBaseService } from "../../services/firebase.service";
import { UploadService } from "../../storage/uploads/shared/upload.service";
import { Upload } from "../../storage/uploads/shared/upload";
import { FormControl } from "@angular/forms";
import { NgModule } from "@angular/core";

import {} from "googlemaps";
import { MapsAPILoader } from "@agm/core";
import {} from "@types/googlemaps";

@Component({
  selector: "app-add-campervan",
  templateUrl: "./add-campervan.component.html",
  styleUrls: ["./add-campervan.component.css"]
})
export class AddCampervanComponent implements OnInit {
  campervan: CamperVan = {
    brand: "",
    description: "",
    img: "",
    location: {},
    ontheroad: false,
    name: "",
    model: "",
    year: 1989,
    mileage: 290845,
    website: "",
    facebook: "",
    instagram: "",
    pinterest: "",
    type: "",
    userId: "",
    imgRef: { url: "", name: "" }
  };

  selectedFiles: FileList | null;
  fileSelected = false;

  currentUpload: Upload;

  myNewDocId: any;
  userId: string;
  imagePreview: any;

  imageSrc: string = "";
  loaded: boolean = false;

  //@ViewChild('search')
  //public searchElementRef: ElementRef;

  private searchElementRef: ElementRef;
  @ViewChild("search")
  set content(content: ElementRef) {
    this.searchElementRef = content;
  }

  lat: number = 51.678418;
  lng: number = 7.809007;

  public latitude: number;
  public longitude: number;
  public searchControl: FormControl;
  public zoom: number = 4;

  data: object = {
    location: {
      lat: "",
      lng: ""
    },
    adress_components: {},
    formatted_address: "",
    plade_id: "",
    url: ""
  };

  myUserId;

  placeValidation = false;

  toggleImage = true;
  toggleLocation = true;

  public mapStyle = [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#444444"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f2f2f2"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: -100
        },
        {
          lightness: 45
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#46bcec"
        },
        {
          visibility: "on"
        }
      ]
    }
  ];

  constructor(
    public auth: AuthService,
    private firebaseService: FireBaseService,
    private uploadService: UploadService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) {
    this.myUserId = auth.getUserId();
  }

  ngOnInit() {
    //set current position
    

    this.latitude = 51.678418;
    this.longitude = 7.809007;
    this.setCurrentPosition();
    
    setTimeout(() => {
      this.loadAutocomplete();
    }, 1000);
    this.searchControl = new FormControl();
  }

  loadAutocomplete() {
    this.lat = 51.678418;
    this.lng = 7.809007;

    //create search FormControl
    //this.searchControl = new FormControl();

    //set current position
    //this.setCurrentPosition();

    console.log("search element ref", this.searchElementRef);

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      console.log(
        "search element ref after THEN ",
        this.searchElementRef.nativeElement
      );
      let autocomplete = new google.maps.places.Autocomplete(
        this.searchElementRef.nativeElement,
        {
          types: ["address"]
        }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          console.log(place);
          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 9;

          this.campervan.location = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };

          this.data = {
            location: {
              lat: this.latitude,
              lng: this.longitude
            },
            adress_components: place.address_components,
            formatted_address: place.formatted_address,
            plade_id: place.id,
            url: place.url
          };

          console.log(this.data);
        });
      });
    });
  }

  toggleImageM() {
    this.toggleImage = false;
  }

  toggleLocationM() {
    this.toggleLocation = false;
  }

  validationForm() {
    if (
      this.campervan.brand !== "" &&
      this.campervan.name &&
      this.campervan.model &&
      this.placeValidation === true &&
      this.selectedFiles.item.length === 1
    ) {
      return true;
    } else {
      return false;
    }
  }

  private setCurrentPosition() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(position => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 10;
      });
    }
  }

  detectFiles($event: Event) {
    this.selectedFiles = ($event.target as HTMLInputElement).files;
    this.fileSelected = true;
    console.log("selected Files ", this.selectedFiles.item);
  }

  uploadSingle(campervan, uid, data) {
    const file = this.selectedFiles;
    console.log("this is my data", data);

    campervan.location = {
      lat: this.latitude,
      lng: this.longitude
    };

    campervan.locationData = data;

    console.log(campervan);
    if (file && file.length === 1) {
      this.currentUpload = new Upload(file.item(0));
      this.uploadService.pushUpload(this.currentUpload, uid, campervan);
    } else {
      console.error("No File Found!");
    }
  }
}





  /*onSubmit(uid, campervan) {

    // save CamperVan in CamperVan Firestore
    this.campervan.userId = uid;

    this.firebaseService.addCamperVan(this.campervan)
    .then(result => console.log(result))

    .catch(error => console.log(error))
    ;

    console.log('My New Doc Id', this.myNewDocId);


    */
    // Upload Picture To Cloud Storage + add ref to campervan Object

    //this.uploadSingle();


    //console.log("Submit Button Clicked");
    //console.log(uid);
    //console.log(this.campervan);


/*
   detectFiles($event: Event){
        this.selectedFiles = ($event.target as HTMLInputElement).files;
      }

      uploadSingle(){
        const file = this.selectedFiles;
        if(file && file.length === 1){
          this.currentUpload = new Upload(file.item(0));
          this.upSvc.pushUpload(this.currentUpload);
        }else{
          console.error('No File Found!');
        }
      }

*/




   /*
    this.lat = 51.678418;
    this.lng = 7.809007;

    //create search FormControl
    this.searchControl = new FormControl();

    

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ['address']
      });
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          } else {
            this.placeValidation = true;
          }



          console.log(place);
          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.zoom = 12;





          this.data = {
            location: {
              lat: this.latitude,
              lng: this.longitude
            },
            adress_components: place.address_components ,
            formatted_address: place.formatted_address,
            plade_id: place.id,
            url: place.url
          };

          console.log(this.data);


        });
      });
    });



    /*this.mapsAPILoader.load().then(
      () => {
        let autocomplete = new google.maps.places.Autocomplete(this.searchElement.nativeElement, { types: ['address']});

        autocomplete.addListener('place_changed', () => {
          this.ngZone.run( () => {
            let place: google.maps.places.PlaceResult =  autocomplete.getPlace();

            if(place.geometry === undefined || place.geometry === null){
              return;
            }
            console.log(place.geometry.location.lat);

          });
        });
      }
    );
    */


// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/loveyourcamper-app/src/app/components/add-campervan/add-campervan.component.ts